import { useState } from "react";
import { Plus, Trash2, User, Pencil, IndianRupee } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useMasters } from "./MastersContext";
import { UpiPayModal } from "../UpiPayModal";

export function DriversSection() {
  const navigate = useNavigate();
  const { dForm, setDForm, addDriver, editIds, drivers, editDriver, delDriver } = useMasters();
  const [payModal, setPayModal] = useState(null);
  return (
    <section>
      <div className="flex items-center gap-2 mb-3"><User className="w-4 h-4 text-[#C84B31]" /><div className="section-title mb-0">Drivers</div></div>
      <form onSubmit={addDriver} className="card-surface p-4 mb-4 space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <input className="input-field" placeholder="Name" value={dForm.name} onChange={(e)=>setDForm({...dForm, name: e.target.value})} required data-testid="driver-name-input" />
          <input className="input-field" placeholder="Phone" value={dForm.phone} onChange={(e)=>setDForm({...dForm, phone: e.target.value})} data-testid="driver-phone-input" />
          <input className="input-field font-mono" placeholder="UPI ID (name@bank)" value={dForm.upi_id} onChange={(e)=>setDForm({...dForm, upi_id: e.target.value})} data-testid="driver-upi-input" />
          <input className="input-field font-mono" placeholder="License No" value={dForm.license_number} onChange={(e)=>setDForm({...dForm, license_number: e.target.value})} data-testid="driver-license-input" />
          <input className="input-field font-mono" placeholder="Aadhaar No" value={dForm.aadhaar_number} onChange={(e)=>setDForm({...dForm, aadhaar_number: e.target.value})} data-testid="driver-aadhaar-input" />
          <input className="input-field col-span-2" placeholder="Notes" value={dForm.notes} onChange={(e)=>setDForm({...dForm, notes: e.target.value})} />
        </div>
        <button type="submit" className="btn-primary" data-testid="add-driver-button"><Plus className="w-4 h-4" /> {editIds.driver ? "Update Driver" : "Add Driver"}</button>
      </form>
      <div className="table-wrap">
        <table className="w-full">
          <thead><tr><th className="table-th">Name</th><th className="table-th">Phone</th><th className="table-th">UPI ID</th><th className="table-th">License</th><th className="table-th text-right"></th></tr></thead>
          <tbody>
            {drivers.length === 0 ? (
              <tr><td className="table-td text-[#68665E] text-center" colSpan={5}>No drivers yet.</td></tr>
            ) : drivers.map((d) => (
              <tr key={d.id} className="table-row" data-testid={`driver-row-${d.id}`}>
                <td className="table-td font-medium"><button className="text-[#C84B31] hover:underline text-left" onClick={()=>navigate(`/entity/driver/${d.id}`)} data-testid={`driver-open-${d.id}`}>{d.name}</button></td>
                <td className="table-td">{d.phone || "—"}</td>
                <td className="table-td font-mono text-xs break-all">{d.upi_id || "—"}</td>
                <td className="table-td font-mono text-xs">{d.license_number || "—"}</td>
                <td className="table-td text-right whitespace-nowrap">
                  <button className="btn-ghost text-[#C84B31]" title="Pay via UPI" onClick={()=>setPayModal({ payee_name: d.name, upi_id: d.upi_id || "", phone: d.phone || "", amount: "", note: `Payment to ${d.name}`, category: "Driver", ref_type: "driver", ref_id: d.id, ref_number: d.name })} data-testid={`driver-pay-${d.id}`}><IndianRupee className="w-4 h-4" /></button>
                  <button className="btn-ghost" onClick={()=>editDriver(d)} data-testid={`driver-edit-${d.id}`}><Pencil className="w-4 h-4" /></button>
                  <button className="btn-ghost text-[#8A2526]" onClick={()=>delDriver(d.id)} data-testid={`driver-delete-${d.id}`}><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <UpiPayModal open={!!payModal} prefill={payModal || {}} onClose={()=>setPayModal(null)} />
    </section>
  );
}
